import { createContext } from 'react';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';

// `parentIds` is the direct-parent set seeded into the form field, never the frozen `ancestorIds` chain.
export type GoalFormSeed = Partial<Goal> & {
  parentIds?: ID[] | null;
};

export type CreateGoalOptions = GoalFormSeed & {
  skipNavigation?: boolean;
  tasks?: Task[];
};

export type GoalFormContextProps = {
  onCreateGoal: (options?: CreateGoalOptions) => void;
  onEditGoal: (initialValues: Partial<Goal>, id: ID) => void;
};

export const GoalFormContext = createContext<GoalFormContextProps>({
  onCreateGoal: () => {},
  onEditGoal: () => {},
});
